function AvailabilityRuleOnlineMeedyVO(id, startTime, endTime, resource, recurrencePattern, repeatWeeklyMonday,
                                 repeatWeeklyTuesday, repeatWeeklyWednesday, repeatWeeklyThursday, repeatWeeklyFriday,
                                 repeatWeeklySaturday, repeatWeeklySunday, startDate, endDate, endless, stationary,
                                videoConsultation, tripCity, tripCity30km, nightCity, nightCity30km, dayDefinitions) {

    this.id = id;
    this.startTime = startTime;
    this.endTime = endTime;
    this.resource = resource;
    this.recurrencePattern = recurrencePattern;
    this.repeatWeeklyMonday = repeatWeeklyMonday;
    this.repeatWeeklyTuesday = repeatWeeklyTuesday;
    this.repeatWeeklyWednesday = repeatWeeklyWednesday;
    this.repeatWeeklyThursday = repeatWeeklyThursday;
    this.repeatWeeklyFriday = repeatWeeklyFriday;
    this.repeatWeeklySaturday = repeatWeeklySaturday;
    this.repeatWeeklySunday = repeatWeeklySunday;
    this.startDate = startDate;
    this.endDate = endDate;
    this.endless = endless;
    this.stationary = stationary;
    this.videoConsultation = videoConsultation;
    this.tripCity = tripCity;
    this.tripCity30km = tripCity30km;
    this.nightCity = nightCity;
    this.nightCity30km = nightCity30km;
    this.dayDefinitions = dayDefinitions;

    var _typeContext = {
        startTime : Date,
        endTime : Date,
        startDate : Date,
        endDate : Date,
        resource : ResourceMeedyVO,
        dayDefinitions : AvailabilityRuleDayOnlineDefinitionMeedyVO

    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
